<template>
  <div class="edu-contact-area ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <!-- Sol Bilgi Alanı -->
        <div class="col-lg-5 col-md-12">
          <div class="edu-content">
            <div class="edu-contact-title">
              <p class="sub-title">İletişim</p>
              <h2>
                Bizimle <span class="shape02">Bugün</span> İletişime Geçin
              </h2>
              <p>Hemen iletişime geçin, size yardımcı olalım.</p>
            </div>

            <div class="edu-contact-info-box">
              <div class="icon">
                <img src="../../assets/img/svg/mail.svg" alt="icon" />
              </div>
              <h3>E-posta :</h3>
              <p>
                <a href="mailto:info@cvision.com.tr">info@cvision.com.tr</a>
              </p>
            </div>

            <div class="edu-contact-info-box">
              <div class="icon">
                <img src="../../assets/img/svg/call.svg" alt="icon" />
              </div>
              <h3>Bizi Arayın:</h3>
              <p>
                <a href="tel:+905555555555">+90 555 555 55 55</a>
              </p>
            </div>
          </div>
        </div>

        <!-- Sağ Form Alanı -->
        <div class="col-lg-7 col-md-12">
          <div class="contact-form">
            <form @submit.prevent="onSubmit">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      name="name"
                      class="form-control"
                      v-model="name"
                      required
                      placeholder="İsim"
                      maxlength="50"
                      @input="validateName"
                    />
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <input
                      type="email"
                      name="email"
                      class="form-control"
                      v-model="email"
                      required
                      placeholder="E-posta"
                      maxlength="80"
                      @input="validateEmail"
                    />
                  </div>
                </div>

                <div class="col-lg-6 col-md-6">
                  <div class="form-group">
                    <input
                      type="text"
                      name="phone"
                      class="form-control"
                      v-model="phone"
                      required
                      placeholder="Telefon Numarası*"
                      maxlength="11"
                      @input="validatePhone"
                    />
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <div class="form-group">
                    <textarea
                      name="message"
                      v-model="message"
                      class="form-control"
                      cols="30"
                      rows="6"
                      required
                      placeholder="Mesajınızı yazın..."
                      maxlength="1000"
                      @input="validateMessage"
                    ></textarea>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12">
                  <button type="submit" class="default-btn" :disabled="loading">
                    <i class="bx bx-paper-plane"></i>
                    {{ loading ? "Gönderiliyor..." : "Mesajı Gönder" }}
                  </button>
                </div>

                <div class="col-lg-12 col-md-12" v-if="result">
                  <p>{{ result }}</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactUs",

  data() {
    return {
      name: "",
      email: "",
      phone: "",
      message: "",
      result: "",
      loading: false,
    };
  },

  methods: {
    validatePhone() {
      this.phone = this.phone.replace(/\D/g, "");

      if (this.phone.length > 11) {
        this.phone = this.phone.slice(0, 11);
      }
    },
    validateName() {
      this.name = this.name
        .replace(/[^a-zA-ZğüşöçıİĞÜŞÖÇ\s]/g, "")
        .slice(0, 50);
    },

    validateEmail() {
      this.email = this.email.slice(0, 80);
    },

    validateMessage() {
      this.message = this.message.slice(0, 500);
    },
    async onSubmit() {
      this.loading = true;
      this.result = "";

      if (this.phone.length !== 11) {
        this.result = "Telefon numarası 11 haneli olmalıdır!";
        setTimeout(() => {
          this.result = "";
        }, 2000);
        this.loading = false;
        return;
      }

      if (this.email.length < 5 || !this.email.includes("@")) {
        this.result = "Geçerli bir e-posta adresi giriniz!";
        setTimeout(() => (this.result = ""), 2000);
        this.loading = false;
        return;
      }

      const formData = new FormData();
      formData.append("access_key", "975f331d-00b8-4e2b-bd3b-71c12f517d42");
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("phone", this.phone);
      formData.append("message", this.message);

      try {
        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          body: formData,
        });

        const data = await response.json();

        if (data.success) {
          this.result = "Mesaj başarıyla gönderildi";
          this.name = "";
          this.email = "";
          this.phone = "";
          this.message = "";

          setTimeout(() => {
            this.result = "";
          }, 2000);
        } else {
          setTimeout(() => {
            this.result = "";
          }, 2000);
        }
      } catch (error) {
        setTimeout(() => {
          this.result = "";
        }, 2000);
      }
      this.loading = false;
    },
  },
};
</script>
